export function getChannelsCustomAttributeDefinitionLabels(attributeName, intl) {
  switch (attributeName) {
    case 'Age Group':
      return intl.t('items.channels.customAttributes.labels.ageGroup');
    case 'Brand':
      return intl.t('items.channels.customAttributes.labels.brand');
    case 'Color':
      return intl.t('items.channels.customAttributes.labels.color');
    case 'Gender':
      return intl.t('items.channels.customAttributes.labels.gender');
    case 'Is Bundle':
      return intl.t('items.channels.customAttributes.labels.isBundle');
    case 'Condition':
      return intl.t('items.channels.customAttributes.labels.condition');
    case 'Multipack':
      return intl.t('items.channels.customAttributes.labels.multipack');
    case 'Size':
      return intl.t('items.channels.customAttributes.labels.size');
    default:
      return attributeName;
  }
}
export function getChannelsCustomAttributeDefinitionOptionLabels(optionName, intl) {
  switch (optionName) {
    case 'Adult':
      return intl.t('items.channels.customAttributes.optionLabels.ageGroup.adult');
    case 'Infant':
      return intl.t('items.channels.customAttributes.optionLabels.ageGroup.infant');
    case 'Kids':
      return intl.t('items.channels.customAttributes.optionLabels.ageGroup.kids');
    case 'Newborn':
      return intl.t('items.channels.customAttributes.optionLabels.ageGroup.newborn');
    case 'New':
      return intl.t('items.channels.customAttributes.optionLabels.condition.new');
    case 'Refurbished':
      return intl.t('items.channels.customAttributes.optionLabels.condition.refurbished');
    case 'Used':
      return intl.t('items.channels.customAttributes.optionLabels.condition.used');
    case 'Male':
      return intl.t('items.channels.customAttributes.optionLabels.gender.male');
    case 'Female':
      return intl.t('items.channels.customAttributes.optionLabels.gender.female');
    case 'Unisex':
      return intl.t('items.channels.customAttributes.optionLabels.gender.unisex');
    default:
      return optionName;
  }
}